import Head from 'next/head';
import { useRouter } from 'next/router';

import { env } from '@/utils/env.mjs';

type Props = {
  title: string;
  image?: string;
  jsonLd?: object;
  keywords?: string[];
  description: string;
  ogType?: 'website' | 'article';
  twitterCardSize?: 'summary_large_image';
  children?: React.ReactNode;
};

const Component: React.FC<Props> = ({
  title,
  image,
  jsonLd,
  keywords,
  description,
  ogType = 'article',
  twitterCardSize = 'summary_large_image',
  children,
}) => {
  const { NEXT_PUBLIC_VERCEL_URL: hostingFqdn } = env;

  const router = useRouter();
  const hostName = `https://${hostingFqdn}`;
  const url = `${hostName}${router.asPath}`;

  return (
    // prettier-ignore
    <Head>
      {/* 共通で固定値を入れるもの */}
      <meta charSet="UTF-8" />
      <meta name="viewport" content="initial-scale=1.0, width=device-width" />
      <meta name="twitter:site" content="@Shakehands_Inc" />
      <meta name="twitter:creator" content="@Shakehands_Inc" />
      <meta property="fb:app_id" content="463337213857171" />
      <meta property="article:publisher" content="https://www.facebook.com/shands.jp" />
      <meta property="og:site_name" content="卓球レッスン動画／動画でまなぶ卓球 シェークハンズ" />

      <link rel="shortcut icon" href={`${hostName}/assets/favicon.ico`} />
      <link rel="apple-touch-icon" href={`${hostName}/assets/favicon.ico`} />

      {/* ページごとに個別に設定するもの */}
      <title>{title}</title>
      <meta property="og:title" content={title} />

      <link rel="canonical" href={url} />
      <meta property="og:url" content={url} />

      <meta name="description" content={description} />
      <meta property="og:description" content={description} />
      <meta property="twitter:description" content={description} />

      {/* ページごとに個別に設定するもの（省略可・デフォルト値あり） */}
      <meta property="og:type" content={ogType} />
      <meta property="og:image" content={image ?? `${hostName}/assets/ogp.png`} />
      <meta property="twitter:image" content={image ?? `${hostName}/assets/ogp.png`} />
      <meta name="twitter:card" content={twitterCardSize} />

      {/* ページごとに個別に設定するもの（省略可・デフォルト値なし） */}
      {keywords && <meta name="keywords" content={keywords.join(',')} />}

      {/* JSON-LD */}
      {jsonLd && <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />}

      {children}
    </Head>
  );
};

export default Component;
